import { Box, VStack } from '@cdl/heartbeat-react';
import { ClusterBeat } from '../../clustering.types';
import { SelectBeat } from './SelectBeat';
import { PinBeat } from './PinBeat';
import { BeatMoreAction } from './BeatMoreAction';

interface Props {
  beat: ClusterBeat;
}
export const BeatActionBar: React.FC<Props> = ({ beat }) => {
  return (
    <VStack flex={1} justifyContent='space-between'>
      <SelectBeat beat={beat} />
      <Box>
        <PinBeat beat={beat} />
        <BeatMoreAction beat={beat} />
      </Box>
    </VStack>
  );
};
